import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import KanbanBoard from "@/components/KanbanBoard";
import { LogIn, ShieldCheck } from "lucide-react";

const COLUMNS = [
  { id: "novo", label: "Novo", accent: "bg-slate-500" },
  { id: "em_inspecao", label: "Em Inspeção", accent: "bg-amber-500" },
  { id: "aguardando_aprovacao", label: "Aguard. Aprovação", accent: "bg-orange-500" },
  { id: "aprovado", label: "Aprovado", accent: "bg-neutral-500" },
  { id: "aguardando_pecas", label: "Aguard. Peças", accent: "bg-purple-500" },
  { id: "em_reparo", label: "Em Reparo", accent: "bg-primary" },
  { id: "pintura", label: "Pintura", accent: "bg-pink-500" },
  { id: "montagem", label: "Montagem", accent: "bg-indigo-500" },
  { id: "quality_check", label: "Quality Check", accent: "bg-cyan-500" },
  { id: "pronto_entrega", label: "Pronto p/ Entrega", accent: "bg-emerald-500" },
  { id: "entregue", label: "Entregue", accent: "bg-neutral-500" },
];

export default function BodyShopKanban() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/jobs", { params: { job_type: "body_shop" } });
    setJobs(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const onStatusChange = async (jobId, newStatus) => {
    await api.patch(`/jobs/${jobId}/status`, { status: newStatus });
  };

  const renderExtra = (j) => {
    const seguradora = j.extra?.seguradora;
    const valor = j.extra?.valor_aprovado;
    if (!seguradora && !valor) return null;
    return (
      <div className="mt-1.5 flex items-center gap-1.5 text-[10px]">
        {seguradora && (
          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-secondary text-foreground truncate">
            <ShieldCheck className="w-2.5 h-2.5" />{seguradora}
          </span>
        )}
        {valor && <span className="font-mono text-emerald-500">${valor.toLocaleString?.("en-US") || valor}</span>}
      </div>
    );
  };

  return (
    <div className="space-y-4 -mt-2" data-testid="body-shop-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Body Shop</div>
          <h1 className="font-display text-3xl font-bold tracking-tight">Kanban Body Shop</h1>
          <p className="text-sm text-muted-foreground mt-1">Fluxo dedicado com seguradora, valor aprovado e estágios de pintura/montagem.</p>
        </div>
        <Button onClick={() => navigate("/check-in?type=body_shop")} data-testid="body-shop-checkin-btn">
          <LogIn className="w-4 h-4" /> Novo Check-In Body Shop
        </Button>
      </div>
      {loading ? <div className="text-sm text-muted-foreground">Carregando…</div> :
        <KanbanBoard columns={COLUMNS} jobs={jobs} onStatusChange={onStatusChange} renderCardExtra={renderExtra} onJobsChanged={load} />}
    </div>
  );
}
